import React, { PureComponent } from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Button, Message, Modal, Select } from "antd";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import fetchHandler from "@/fetch/fetchHandler";
import { addTask } from "@/fetch/fetchApi";
import CfgChangeTaskBuild from "./cfgChangeTaskBuild";

const { Option } = Select;

@connect((state) => state)
class TaskSelectClass extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.taskSelect;
    this.state = {
      type: -1,
      taskId: "",
    };
  }

  componentWillMount() {
    const date = new Date();
    const time = `${date.getFullYear()
    }${
      date.getMonth() + 1 < 10
        ? `0${date.getMonth() + 1}`
        : date.getMonth() + 1
    }${
      date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
    }${
      date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
    }${
      date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
    }${
      date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()}`;
    const userName = window.sessionStorage.getItem("name");
    this.setState({
      taskName: userName + time,
      userName: userName,
    });
  }

  handleCfgChangeBtnClick = () => {
    this.setState({
      type: 0,
    });
  };

  handleFirmwareUpdateBtnClick = () => {
    this.setState({
      type: 1,
    });
  };

  handleCreateTaskBtnClick = () => {
    // 往数据库任务表插入一条数据
    fetchHandler(addTask, {
      operationName: this.state.taskName,
      type: this.state.type,
    }).then((res) => {
      this.setState(
        {
          taskId: res.data,
        },
        () => {
          if (this.state.type === "") {
            Message.warning(this.internationalization.placeholder1, 1);
          } else if (this.state.type === 0) {
            this.props.onCancel();
            this.props.addTab(
              {
                key: "taskBuildStep",
                titleText: "批量配置修改",
              },
              {
                taskName: this.state.taskName,
                taskId: this.state.taskId,
                createAccount: this.state.userName,
              },
            );
            // this.setState({
            // },()=>{taskName={this.state.taskName} taskId={this.state.taskId}
            //     this.setState({
            //         seeCfgChangeTaskBuildVisible:true
            //     })
            // })
          }
        },
      );
    });
  };

  changeTaskType = (value) => {
    this.setState(
      {
        type: +value,
      },
      () => {
        console.log(this.state);
      },
    );
  };

  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  render() {
    return (
      <div>
        <div style={{ textAlign: "center" }}>
          <span style={{ fontSize: "18px" }}>
            {this.internationalization.placeholder1}
          </span>
        </div>
        <br />
        <br />
        <div style={{ textAlign: "center" }}>
          {/* <Button onClick={this.handleCfgChangeBtnClick}>配置修改</Button> */}
          <Select
            onSelect={this.changeTaskType}
            placeholder="选择任务类型"
            style={{ width: "126px" }}
          >
            <Option value="0">{this.internationalization.btn1}</Option>
          </Select>
        </div>
        <br />
        <br />
        <div style={{ textAlign: "center" }}>
          <Button
            type="primary"
            onClick={this.handleCreateTaskBtnClick}
            disabled={this.state.type === -1}
          >
            {this.internationalization.btn2}
          </Button>
        </div>

        <Modal
          title={this.internationalization.modaltitle1}
          visible={this.state.seeCfgChangeTaskBuildVisible}
          footer={null}
          destroyOnClose
          width="1000px"
          onCancel={() => {
            this.modalVisibleAction("seeCfgChangeTaskBuildVisible", false);
          }}
        >
          <CfgChangeTaskBuild
            taskName={this.state.taskName}
            taskId={this.state.taskId}
            onCancel={() => {
              this.modalVisibleAction("seeCfgChangeTaskBuildVisible", false);
              this.props.onCancel();
            }}
            refreshGrid={() => {
              this.props.refreshGrid();
            }}
          />
        </Modal>
      </div>
    );
  }
}

const TaskSelect = Form.create()(TaskSelectClass);

export default injectIntl(TaskSelect);



// WEBPACK FOOTER //
// ./src/AntD/pages/onlineOperations/taskManagement/taskSelect.js